import {ArrowRight, Star} from "lucide-react";
import React from "react";
import heroBg from "./assets/hero_bg.png";
import reverse_autonomous_machine from "./assets/reverse_autonomous_machine.svg";

{/* Hero Section */
}
export default function Hero() {
    return (
        <section id="home"
                 className="	 relative mt-[5rem] md:mt-[10rem]  px-4 py-6 w-full mx-auto max-w-[101.25rem] min-h-[37.5rem] bg-contain bg-no-repeat bg-[150px_180px] md:bg-[300%_-150px] lg:bg-[201%_-145px]  xl:bg-[right_-145px] "
                 style={{backgroundImage: `url(${heroBg})`, backgroundSize: '40.5rem 40.5rem'}}>
            <h2 className="bg-black text-white w-fit md:max-w-[24rem] lg:max-w-[39rem]  xl:max-w-max p-2 text-[2.25rem] md:text-[2rem] lg:text-[2.25rem] xl:text-4xl leading-[1.2] font-semibold ">Building the Future, Autonomously</h2>
            <p className="text-[1.5rem] md:text-[1.125rem] mb-[23rem] md:mb-[10rem] lg:max-w-[39rem]  xl:max-w-[42.5rem] md:max-w-[26rem] max-w-[42.5rem]  p-5 md:h-auto h-[20rem] ">Autonomous
                Machines delivers an integrated software and hardware system that accelerates photovoltaic park
                construction, reducing costs and increasing safety with autonomous specialized construction
                vehicles.</p>
            <h2 id="features" className="bg-black text-white w-fit p-2 text-4xl font-semibold">Our Technology</h2>
            <p className="text-[1.5rem] md:text-[1.125rem] p-5 max-w-[42.5rem] mb-[3.75rem]">Autonomous Machines
                combines advanced robotics and AI to deliver a fully autonomous pile-driving system for solar park
                construction. The system includes:</p>

            <div className="grid md:grid-cols-3 gap-[1.1rem] lg:gap-8">
                {[
                    {

                        title: "Autonomous Pile-Driving Robot (RB)",
                        description: "Equipped with GPS RTK, LiDAR, and AI-based navigation, it ensures precision and speed in pile installation."
                    },
                    {

                        title: "Transport & Supply Robot (RTA)",
                        description: "Carries and feeds piles to the RB, enabling continuous operation through autonomous navigation and hybrid propulsion."
                    },
                    {

                        title: "Communication & Coordination Module (MOC)",
                        description: "Manages local fleet orchestration without needing a live internet connection, ensuring real-time task allocation and efficiency."
                    }
                ].map((feature, index) => (
                    <div key={index}
                         className="group bg-white  p-0  transition-all duration-300 hover:transform hover:scale-105">

                        <h3 className="text-[1.1rem] sm:text-lg lg:text-xl font-bold text-black bg-yellow p-2 xl:p-4 mb-4 w-fit">{feature.title}</h3>
                        <p className="text-[1.1rem]  sm:text-blackleading-relaxed p-4 xl:p-8">{feature.description}</p>
                    </div>
                ))}

            </div>
            <p className="mb-[5rem] mt-[3rem] p-5 max-w-[35.5rem]">Our modular, scalable design allows deployment across
                uneven terrains, minimizing human intervention while maximizing operational uptime and safety.</p>
            <div
                className="absolute  top-[500px] left-[120px] md:top-[100px] md:left-1/2 transform -translate-x-[30%] md:translate-x-[30px] lg:translate-x-[24%] xl:-translate-x-[30%] z-40 w-[19rem] md:w-[23rem] ">
                <img src={reverse_autonomous_machine}/>
            </div>
        </section>
    );
}